import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'name',
		title: 'global.name',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'organization',
		title: 'global.organization',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'producer',
		title: 'global.producer',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'domain',
		title: 'global.domain',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'last8chars',
		title: 'global.last8chars',
		sortable: false,
		defaultVisible: true,
	},
	{
		accessor: 'updatedAt',
		title: 'global.lastUsedDate',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'createdAt',
		title: 'global.createdAt',
		sortable: true,
		defaultVisible: false,
	},
	{
		type: 'apiTokensActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		width: 50,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
